import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import {computed} from 'vue';
import ReviewsList from "~/chat/vue/widget/tabs/reviews/ReviewsList.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import ReviewFormContent from "~/chat/vue/widget/tabs/reviews/ReviewFormContent.vue";


const __default__ = {
    name: "ReviewsTabContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["scroll-to"],
  setup(__props, { emit: __emit }) {

let emits = __emit;


let loadInTab = computed(() => {
    return rateConfig.value.loadInTab;
});

let rateConfig = computed(() => {
    return ConfigStore.siteParams.value.params.rate;
});


return (_ctx: any,_cache: any) => {
  return (_unref(loadInTab))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ReviewsList, {
          class: "reviews-list",
          onScrollTo: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('scroll-to', $event))),
          "display-city": _unref(rateConfig).listInWidget.displayCity,
          "display-date": _unref(rateConfig).listInWidget.displayDate,
          "display-name": _unref(rateConfig).listInWidget.displayName,
          "display-rate-value": _unref(rateConfig).listInWidget.displayRateValue
        }, null, 8, ["display-city", "display-date", "display-name", "display-rate-value"])
      ]))
    : (_openBlock(), _createBlock(ReviewFormContent, { key: 1 }))
}
}

})